import { WarId, DbStructure, CountriesModel, EventsModel, CategoriesModel } from '@/models/sidebar/info.model';

const dbMap: Record<WarId, () => Promise<{ default: DbStructure }>> = {
  '1948-arab-israeli-war': () => import('@/helpers/blob-1948.min.json') as unknown as Promise<{ default: DbStructure }>,
  'suez-crisis': () => import('@/helpers/blob-1956.min.json') as Promise<{ default: DbStructure }>
};

export const mapCountryByKey = (countryObject: CountriesModel, keyName: string, lang: string): string => {
  const key = `${keyName}_${lang}`;
  return lang !== 'en' && key in countryObject ? countryObject[key] : countryObject[keyName];
};

export const mapEventByKey = (eventObject: EventsModel, keyName: string, lang: string): string | number | number[] | undefined => {
  const key = `${keyName}_${lang}`;
  return lang !== 'en' && key in eventObject ? eventObject[key] : eventObject[keyName];
};

export const mapCategoryByKey = (categoryObject: CategoriesModel, keyName: string, lang: string): string | number => {
  const key = `${keyName}_${lang}`;
  return lang !== 'en' && key in categoryObject ? categoryObject[key] : categoryObject[keyName];
};

export const loadWarDatabase = async (warId: WarId): Promise<DbStructure | null> => {
  const dbLoader = dbMap[warId];
  if (!dbLoader) {
    return null;
  }

  const dbModule = await dbLoader();
  return dbModule.default;
};
